function assingInputValueByName(name, value, scope) {
  const _selector = (scope ? `${scope} ` : '') + `input[name=${name}]`;
  const _element = document.querySelector(_selector);

  if (_element) {
    _element.value = value;
  }
}

module.exports = {
  assingInputValueByName,
}
